export const CUSTOM_EVENT_HIDEQUICKNAV = 'custom:hidequicknav';
import { remToPxStatic } from '../../../src/js/helpers.js';

const colours = ['off-white', 'forest', 'cornflower', 'lilac'];

class MobileNavTrigger extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.button.addEventListener('click', this._toggle);

    this.template = Array.from(document.getElementsByTagName('body')[0].classList).find(
      (className) => className.includes('page--')
    );
  }

  _toggle = () => {
    const expanded = eval(this.button.getAttribute('aria-expanded'));
    const controlled = document.getElementById(this.button.getAttribute('aria-controls'));
    const mobileNavNode = controlled.getElementsByClassName('site-header__mb-nav')[0];

    this.button.setAttribute('aria-expanded', !expanded);

    this.button.classList.toggle('site-header__mb-nav-trigger--open');
    controlled.classList.toggle('mobile-nav-container--open');
    document.body.classList.toggle('body--mobile-menu-open');
    if (!expanded) {
      let colourList = colours;
      if (this.template === 'page--about' || this.template.includes('cornflower')) {
        colourList = colourList.filter((c) => c !== 'cornflower');
      } else if (this.template.includes('forest')) {
        colourList = colourList.filter((c) => c !== 'forest');
      } else if (this.template === 'page--news') {
        colourList = colourList.filter((c) => c !== 'lilac');
      }
      const randCol = colourList[Math.floor(Math.random() * colourList.length)];
      mobileNavNode.style.setProperty('--site-header--mb-bg', `var(--colour--${randCol})`);
    }
  };
}

window.customElements.define('boga-mobilenavtrigger', MobileNavTrigger);

class QuickNav extends HTMLElement {
  constructor() {
    super();

    this.body = document.getElementsByTagName('body')[0];
    this.lastScrollTop = window.scrollY || document.documentElement.scrollTop;

    window.addEventListener('scroll', this.handleScroll.bind(this), false);
    window.addEventListener(CUSTOM_EVENT_HIDEQUICKNAV, this._handleHide);
  }

  handleScroll() {
    if (document.body.style.getPropertyValue('position') === 'fixed') {
      return;
    }
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    // get nav height
    const style = getComputedStyle(this.body);
    const navHeight = remToPxStatic(style.getPropertyValue('--main-nav-height').split('rem')[0]);
    const pageTitleScrolltop = document
      .getElementsByClassName('page-title__title')[0]
      .getBoundingClientRect().y;

    //check is nav is scrolled past
    if (pageTitleScrolltop - navHeight < 0) {
      // apply quicknav styles if scrolled past
      this.body.classList.add('body--quicknav');
      // delay transitions happening so nav doesn't reappear
      setTimeout(() => {
        this.body.classList.add('body--quicknav-transition');
      }, 500);

      if (scrollTop > this.lastScrollTop) {
        // if down scrolling hide nav
        this.body.classList.remove('body--quicknav-visible');
      } else {
        // if up scrolling show nav
        this.body.classList.add('body--quicknav-visible');
      }
    } else {
      // remove quicknav styles when scrolling back to top
      this.body.classList.remove('body--quicknav');
      this.body.classList.remove('body--quicknav-visible');
      // remove transitions class once animation finishes
      setTimeout(() => {
        this.body.classList.remove('body--quicknav-transition');
      }, 550);
    }
    this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  }

  _handleHide = () => {
    this.body.classList.remove('body--quicknav-visible');
  };
}

window.customElements.define('boga-quicknav', QuickNav);
